import React from 'react';
import { RouteComponentProps } from 'react-router';
import { PopupListContainer } from '../../epic/popup-list';

export const Page: React.FC<RouteComponentProps> = () => {
  return <PopupListContainer />;
};
